"use client";
import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { cn as c } from "../../utils/cn.js";
import { setComponentColor as d } from "../../utils/setComponentColor.js";
import { memo as f } from "react";
import "../../vars/variants.js";
import "../../components/badge/Badge.js";
import "../../components/button/Button.js";
import "next/link";
import "../../components/button/button-group-context.js";
import { Icon as s } from "../../components/icon/font/Icon.js";
import "../../components/icon/svg/IconSVG.js";
import "../../components/modals/portal-modal/PortalProvider.js";
import "../../components/modals/router-modal/ModalProvider.js";
import "../../components/modals/portal-modal/PortalModal.js";
import "../../components/modals/router-modal/RouterModal.js";
import "../../components/modals/base/ModalContent.js";
import "../../components/modals/base/ModalFooter.js";
import "../../components/modals/base/ModalHeader.js";
import "../../components/spinner/Spinner.js";
import { STYLES as t } from "./styles.js";
const N = f(
  ({ color: r = "secondary", title: a, icon: n, text: l, isActive: i, isDone: m, timer: e }) => /* @__PURE__ */ p(
    "div",
    {
      className: c(
        t.base,
        i && t.state.current,
        i && !m && t.state.active,
        m && t.state.done
      ),
      style: d(r),
      children: [
        e ? /* @__PURE__ */ p("div", { className: t.timer, children: [
          /* @__PURE__ */ o(s, { size: 4, icon: "timer" }),
          e
        ] }) : a,
        /* @__PURE__ */ o(
          s,
          {
            size: 10,
            color: r,
            icon: m ? "check_circle" : n,
            className: c(m && [t.iconDone])
          }
        ),
        /* @__PURE__ */ o("div", { className: t.textPlate, children: l })
      ]
    }
  )
);
N.displayName = "GiftItem";
export {
  N as GiftItem
};
